import styled from '@emotion/styled'
import { Grid as MaterialGrid, Typography } from '@mui/material'

const Grid = styled(MaterialGrid)`
	${({ theme }) => `
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid ${theme.palette.borderColors.darkGray};
	`}
`

const Title = styled(Typography)`
	text-transform: none;
	font-size: 2rem;
`

const DropdownWrapper = styled.span`
	${({ theme: { spaces } }) => `
		padding-left: ${spaces.m};
	`}
`
export { DropdownWrapper, Grid, MaterialGrid, Title }
